const googleSearch = (text) => {
    if (!text || typeof text !== "string") return; 

    const searchText = encodeURI(text.replaceAll("&", "e"));
    window.open('http://google.com/search?q=' + searchText)
}

export default googleSearch;